import { BackendOnlyResource as e } from "./BackendOnlyResource.js";
import { API as t, Resource as n } from "@coveo/platform-client";
//#region src/resources/DataServiceResource.ts
var r = (e) => "errorInfo" in e, i = (e) => !e.queryResponses.some(r), a = async (e) => {
	let t = await e;
	if (i(t)) return t;
	throw Object.defineProperty(Error(t.queryResponses.reduce((e, t, n) => r(t) ? e + `\n [${n}] ${t.errorInfo.errorCode}` : e, "Queries encountered one or more errors:")), "queryResponses", {
		enumerable: !0,
		value: t.queryResponses
	});
}, o = class e extends n {
	static {
		this.baseUrl = `/rest/organizations/${t.orgPlaceholder}/data/v1`;
	}
	listTables(t, n) {
		return this.api.get(super.buildPath(`${e.baseUrl}/tables`, t), n);
	}
	query(t, n) {
		return this.api.post(super.buildPath(`${e.baseUrl}/query`), t, n);
	}
	queries(t, n) {
		return a(this.api.post(super.buildPath(`${e.baseUrl}/queries`), t, n));
	}
	export(t, n) {
		return this.api.post(super.buildPath(`${e.baseUrl}/export`), t, n);
	}
}, s = class n extends e {
	static {
		this.baseUrl = `/data/restricted/organizations/${t.orgPlaceholder}/data/v1`;
	}
	constructor(e, t, n) {
		super(e, t, n);
	}
	listTables(e, t) {
		return this.internalAPI.get(super.buildPath(`${n.baseUrl}/tables`, e), t);
	}
	query(e, t) {
		return this.internalAPI.post(super.buildPath(`${n.baseUrl}/query`), e, t);
	}
};
//#endregion
export { o as DataServiceResource, s as RestrictedDataServiceResource };

//# sourceMappingURL=DataServiceResource.js.map